export default "__VITE_ASSET__CPdzRWId__"